import { fetchData } from './fetch';

let restaurants;
let defaultCoordinates;

window.initYMap = () => {
  const mapControls = document.querySelector('.map-controls');
  const mapWrapper = document.querySelector('.map-wrapper');
  const zoomPlusButton = document.querySelector('.plus-button');
  const zoomMinusButton = document.querySelector('.minus-button');
  const searchInput = document.querySelector('.search-input');
  const searchList = document.querySelector('.search-list');
  const searchListOverlay = document.querySelector('.search-list-overlay');
  const showPolygonsBtn = document.querySelector('.show-polygons-button');

  if (mapWrapper) {
    const cityId = mapWrapper.dataset.city;
    const pinPath = mapWrapper.dataset.pin;

    if (mapControls) {
      mapControls.classList.remove('hidden');
    }

    const coordinates = [];

    let currentCityRestaurants = restaurants.filter(
      (restaurant) => restaurant.cityId === cityId,
    );

    if (currentCityRestaurants) {
      currentCityRestaurants.forEach((restaurant) =>
        coordinates.push([restaurant.lat, restaurant.lng]),
      );
    }

    let zoom = 11;

    const init = () => {
      const restaurantsMap = new ymaps.Map(
        'map',
        {
          center: [defaultCoordinates.lat, defaultCoordinates.lng],
          zoom,
          controls: [],
        },
        {
          restrictMapArea: [
            [10, 10],
            [85, -160],
          ],
          suppressMapOpenBlock: true,
        },
      );

      objectManager = new ymaps.ObjectManager({
        gridSize: 32,
      });

      const location = ymaps.geolocation.get();

      location.then(
        function(result) {
          restaurantsMap.geoObjects.add(result.geoObjects)
        },
        function(err) {
          console.log('Ошибка: ' + err)
        }
      );

      if (coordinates.length) {
        const polygon = new ymaps.Polygon(
          [coordinates],
          {},
          {
            interactivityModel: 'default#transparent',
            strokeWidth: 0,
            opacity: 0,
          },
        );

        restaurantsMap.geoObjects.add(polygon);
        const pixelBounds = polygon.geometry.getBounds();

        if (pixelBounds) {
          const result = ymaps.util.bounds.getCenterAndZoom(
            pixelBounds,
            restaurantsMap.container.getSize(),
          );

          if (result) {
            let mapZoom = result.zoom - 1;

            if (coordinates.length < 2) {
              mapZoom = zoom;
            } else {
              zoom = mapZoom;
            }

            restaurantsMap.setCenter(result.center, mapZoom);
          }
        }
      }

      restaurantsMap.behaviors.disable('scrollZoom');

      if (window.innerWidth <= 895) {
        restaurantsMap.events.add('boundschange', (event) => {
          if (event.get('newZoom') != event.get('oldZoom')) {
            zoom = restaurantsMap.getZoom();
          }
        });
      }


      const getPolygons = async () => {
        const polygons = [];

        const response = await fetchData(`/cities/${cityId}`);

        if (response && response.data && response.data.deliveryZones) {
          response.data.deliveryZones.forEach((item) => {
            const coordinates = item.coordinates.map((coordinate) => [coordinate.lat, coordinate.lon]);

            const myPolygon = new ymaps.Polygon([
              coordinates,
            ], {
              hintContent: item.name,
              balloonContent: [
                `<div class="restaurant-address very-small-text bold">${item.name}</div>`,
              ],
            }, {
              fillColor: '#ffd21e',
              strokeColor: '#CCCC00',
              opacity: 0.7,
              strokeWidth: 3.000,
            });

            polygons.push(myPolygon)
          });
        }

        const setPolygons = () => {
          polygons.forEach((polygon) => {
            restaurantsMap.geoObjects.add(polygon);
          });
        }

        setPolygons();

        if (showPolygonsBtn) {
          showPolygonsBtn.addEventListener('click', () => {
            if (showPolygonsBtn.classList.contains('active')) {
              showPolygonsBtn.classList.remove('active');

              polygons.forEach((polygon) => {
                restaurantsMap.geoObjects.remove(polygon);
              });
            } else {
              showPolygonsBtn.classList.add('active');
              setPolygons();
            }
          });
        }
      }

      getPolygons();

      let searchTimeout;

      if (searchInput) {
        searchInput.addEventListener('input', (e) => {
          clearTimeout(searchTimeout);
          const { value } = e.target;

          if (value) {
            searchTimeout = setTimeout(async () => {
              const response = await fetchData(`/cities?searchText=${value}`);

              if (response) {
                if (searchList) {
                  searchList.classList.add('visible');
                  searchList.innerHTML = '';

                  if (searchListOverlay) {
                    searchListOverlay.classList.add('active');
                  }

                  if (response.length) {
                    response.forEach((city) => {
                      const li = document.createElement('li');
                      const button = document.createElement('button');

                      button.classList.add(
                        'city',
                        'bold',
                        'very-small-text',
                      );
                      button.setAttribute('type', 'button');
                      button.dataset.lat = city.lat;
                      button.dataset.lng = city.lng;
                      button.dataset.city = city.id;

                      button.textContent = city.name;

                      li.append(button);
                      searchList.append(li);
                    });
                  } else {
                    searchList.innerHTML =
                      '<li class="very-small-text empty">Ничего не найдено</li>';
                  }
                }
              }
            }, 400);
          } else {
            if (searchList) {
              searchList.classList.remove('visible');
              searchList.innerHTML = '';
            }
          }
        });
      }

      if (searchList) {
        searchList.addEventListener('click', (e) => {
          if (e.target.classList.contains('city')) {
            const { lat, lng } = e.target.dataset;
            const cityId = e.target.dataset.city;

            const coordinates = [];

            currentCityRestaurants = restaurants.filter(
              (restaurant) => restaurant.cityId === cityId,
            );

            if (currentCityRestaurants) {
              currentCityRestaurants.forEach((restaurant) =>
                coordinates.push([restaurant.lat, restaurant.lng]),
              );
            }

            if (searchInput) {
              searchInput.value = e.target.innerHTML;
            }

            if (coordinates.length) {
              const polygon = new ymaps.Polygon(
                [coordinates],
                {},
                {
                  interactivityModel: 'default#transparent',
                  strokeWidth: 0,
                  opacity: 0,
                },
              );

              restaurantsMap.geoObjects.add(polygon);
              const pixelBounds = polygon.geometry.getBounds();

              if (pixelBounds) {
                const result = ymaps.util.bounds.getCenterAndZoom(
                  pixelBounds,
                  restaurantsMap.container.getSize(),
                );

                if (result) {
                  let mapZoom = result.zoom;

                  if (coordinates.length < 2) {
                    mapZoom = zoom;
                  } else {
                    zoom = mapZoom;
                  }

                  restaurantsMap.setCenter(result.center, mapZoom);
                }
              }
            } else {
              restaurantsMap.setCenter([lat, lng], zoom, {
                checkZoomRange: true,
              });
            }

            searchList.innerHTML = '';
            searchList.classList.remove('visible');

            if (searchListOverlay) {
              searchListOverlay.classList.remove('active');
            }
          }
        });
      }

      if (searchListOverlay) {
        searchListOverlay.addEventListener('click', () => {
          searchListOverlay.classList.remove('active');

          if (searchList) {
            searchList.innerHTML = '';
            searchList.classList.remove('visible');
          }
        });
      }

      if (zoomPlusButton) {
        zoomPlusButton.addEventListener('click', () => {
          zoom++;

          if (zoom > 4) {
            if (
              zoomMinusButton &&
              zoomMinusButton.classList.contains('disabled')
            ) {
              zoomMinusButton.classList.remove('disabled');
            }
          }

          if (zoom === 19) {
            zoomPlusButton.classList.add('disabled');
          }

          restaurantsMap.setZoom(zoom);
        });
      }

      if (zoomMinusButton) {
        zoomMinusButton.addEventListener('click', () => {
          zoom--;

          if (zoom < 19) {
            if (
              zoomPlusButton &&
              zoomPlusButton.classList.contains('disabled')
            ) {
              zoomPlusButton.classList.remove('disabled');
            }
          }

          if (zoom === 4) {
            zoomMinusButton.classList.add('disabled');
          }

          restaurantsMap.setZoom(zoom);
        });
      }

      const foodCourtIcon =
        '<svg width="10" height="9" viewBox="0 0 10 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 1.91111C2.23858 1.91111 2.38426e-07 4.2641 2.38426e-07 7.16667L0.909091 7.16667C0.909091 4.79184 2.74065 2.86667 5 2.86667C7.25935 2.86667 9.09091 4.79184 9.09091 7.16667L10 7.16667C10 4.2641 7.76143 1.91111 5 1.91111Z" fill="#757575"/><path d="M0 7.64444H10V8.6H0V7.64444Z" fill="#757575"/><path d="M2.38426e-07 7.16667C2.38426e-07 6.63893 0.407014 6.21111 0.909091 6.21111H9.09091C9.59299 6.21111 10 6.63893 10 7.16667L2.38426e-07 7.16667Z" fill="#757575"/><path fill-rule="evenodd" clip-rule="evenodd" d="M5 2.86667C5.75312 2.86667 6.36364 2.22494 6.36364 1.43333C6.36364 0.641722 5.75312 0 5 0C4.24688 0 3.63636 0.641722 3.63636 1.43333C3.63636 2.22494 4.24688 2.86667 5 2.86667ZM5 1.91111C5.25104 1.91111 5.45455 1.69721 5.45455 1.43333C5.45455 1.16945 5.25104 0.955555 5 0.955555C4.74897 0.955555 4.54545 1.16945 4.54545 1.43333C4.54545 1.69721 4.74897 1.91111 5 1.91111Z" fill="#757575"/></svg>';
      const deliveryIcon =
        '<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.99649 2.91087C9.9989 2.87925 9.9989 2.8475 9.99649 2.81588L8.99684 0.316188C8.9578 0.217378 8.8883 0.133579 8.79843 0.0769452C8.70855 0.0203118 8.60298 -0.0062102 8.49701 0.00122655H1.49947C1.39937 0.00112962 1.30154 0.0311003 1.21866 0.0872564C1.13579 0.143413 1.07168 0.223167 1.03464 0.316188L0.0349877 2.81588C0.0325784 2.8475 0.0325784 2.87925 0.0349877 2.91087C0.0183789 2.9387 0.00655248 2.96912 0 3.00086C0.00556334 3.34644 0.100578 3.68467 0.275775 3.98258C0.450973 4.28048 0.700373 4.52788 0.999649 4.70065V9.50006C0.999649 9.63265 1.05231 9.75982 1.14604 9.85357C1.23978 9.94733 1.36691 10 1.49947 10H8.49701C8.62958 10 8.75671 9.94733 8.85044 9.85357C8.94418 9.75982 8.99684 9.63265 8.99684 9.50006V4.72065C9.29901 4.54616 9.55026 4.29561 9.72563 3.99391C9.901 3.6922 9.99438 3.34984 9.99649 3.00086C10.0012 2.97105 10.0012 2.94068 9.99649 2.91087ZM5.49807 9.00012H4.49842V7.00037H5.49807V9.00012ZM7.99719 9.00012H6.49772V6.50043C6.49772 6.36784 6.44506 6.24068 6.35132 6.14692C6.25759 6.05316 6.13046 6.00049 5.99789 6.00049H3.9986C3.86603 6.00049 3.7389 6.05316 3.64517 6.14692C3.55143 6.24068 3.49877 6.36784 3.49877 6.50043V9.00012H1.9993V5.00061C2.28393 4.99901 2.56494 4.93663 2.82353 4.81765C3.08213 4.69867 3.31234 4.52583 3.49877 4.3107C3.68639 4.52349 3.91713 4.69391 4.17566 4.81064C4.43419 4.92737 4.71459 4.98774 4.99824 4.98774C5.2819 4.98774 5.5623 4.92737 5.82083 4.81064C6.07936 4.69391 6.3101 4.52349 6.49772 4.3107C6.68415 4.52583 6.91436 4.69867 7.17295 4.81765C7.43155 4.93663 7.71256 4.99901 7.99719 5.00061V9.00012ZM7.99719 4.00074C7.73207 4.00074 7.4778 3.89539 7.29033 3.70788C7.10286 3.52037 6.99754 3.26604 6.99754 3.00086C6.99754 2.86827 6.94488 2.74111 6.85115 2.64735C6.75741 2.55359 6.63028 2.50092 6.49772 2.50092C6.36516 2.50092 6.23802 2.55359 6.14429 2.64735C6.05055 2.74111 5.99789 2.86827 5.99789 3.00086C5.99789 3.26604 5.89257 3.52037 5.7051 3.70788C5.51763 3.89539 5.26337 4.00074 4.99824 4.00074C4.73312 4.00074 4.47886 3.89539 4.29139 3.70788C4.10392 3.52037 3.9986 3.26604 3.9986 3.00086C3.9986 2.86827 3.94594 2.74111 3.8522 2.64735C3.75846 2.55359 3.63133 2.50092 3.49877 2.50092C3.36621 2.50092 3.23908 2.55359 3.14534 2.64735C3.05161 2.74111 2.99895 2.86827 2.99895 3.00086C3.00387 3.13216 2.98289 3.26315 2.9372 3.38635C2.89151 3.50954 2.82201 3.62253 2.73266 3.71886C2.64332 3.81519 2.53588 3.89297 2.41648 3.94777C2.29708 4.00257 2.16806 4.03331 2.03678 4.03823C1.77166 4.04818 1.51345 3.95237 1.31895 3.77189C1.22264 3.68252 1.14487 3.57506 1.09009 3.45563C1.0353 3.33621 1.00457 3.20715 0.999649 3.07585L1.83935 1.0011H8.15714L8.99684 3.07585C8.97789 3.32783 8.86427 3.56329 8.67881 3.73487C8.49335 3.90646 8.24982 4.00145 7.99719 4.00074Z" fill="#757575"/></svg>';
      const pickupIcon =
        '<svg width="10" height="12" viewBox="0 0 10 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.49865 0.994141L9.99842 9.99001C10.0292 10.5446 9.60462 11.0192 9.05002 11.05L9.02214 11.0511L8.99423 11.0515H1.00574C0.450286 11.0515 0 10.6013 0 10.0458L0.000388149 10.0179L0.00154944 9.99001L0.50132 0.994141H9.49865ZM1.45278 1.99988L1.00578 10.0458H8.99428L8.54728 1.99988H1.45278ZM3.4914 3.00562H2.48566V4.26279C2.48566 5.47003 3.65394 6.52571 5.00001 6.52571C6.34607 6.52571 7.51436 5.47003 7.51436 4.26279V3.00562H6.50862V4.26279C6.50862 4.89056 5.81207 5.51997 5.00001 5.51997C4.18794 5.51997 3.4914 4.89056 3.4914 4.26279V3.00562Z" fill="#757575"/></svg>';
      const virtualQueueIcon =
        '<svg width="9" height="11" viewBox="0 0 9 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.12969 10.6997H1.15699L0.670654 10.6997V9.72704H1.15699V5.34987V1.45906V0H2.12969L2.12969 0.486351H8.99929L7.54084 3.40442L8.99992 6.32258H2.12969L2.12969 9.72704H2.61606V10.6997L2.12969 10.6997ZM2.12969 1.45906V5.34987H7.42602L6.45334 3.40451L7.42568 1.45906H2.12969Z" fill="#757575"/></svg>';

      restaurants.forEach((restaurant) => {
        let foodCourtType = '';
        let virtualQueueType = '';
        let pickupType = '';
        let deliveryType = '';

        if (restaurant.pickupAvailable) {
          pickupType = `<div class="type">${pickupIcon}</div>`;
        }

        if (restaurant.deliveryAvailable) {
          deliveryType = `<div class="type">${deliveryIcon}</div>`;
        }

        if (restaurant.foodCourt) {
          foodCourtType = `<div class="type">${foodCourtIcon}</div>`;
        }

        if (restaurant.virtualQueue) {
          virtualQueueType = `<div class="type">${virtualQueueIcon}</div>`;
        }

        if (restaurant.lat && restaurant.lng) {
          const mapMarker = new ymaps.Placemark(
            [restaurant.lat, restaurant.lng],
            {
              hintContent: `${restaurant.city.name} ${restaurant.street ? restaurant.street.name: ''}, ${restaurant.house}`,
              balloonContent: [
                `<div class="restaurant-address very-small-text bold">${restaurant.city.name} ${restaurant.street ? restaurant.street.name: ''}, ${restaurant.house}</div><div class="restaurant-work-time very-small-text">Время работы: ${restaurant.cafeWorkingHoursStart} - ${restaurant.cafeWorkingHoursEnd}</div><div class="restaurant-service-types">${pickupType}${deliveryType}${foodCourtType}${virtualQueueType}</div>`,
              ],
            },
            {
              iconLayout: 'default#image',
              iconImageHref: pinPath,
              iconImageSize: [36, 49],
              iconImageOffset: [-5, -38],
              balloonOffset: [-15, -25],
              hideIconOnBalloonOpen: false,
            },
          );

          mapMarker.events.add('balloonopen', (e) => {
            var target = e.get('target');
            if (target.geometry && typeof target.getGeoObjects) {
              target.options.set('iconImageSize', [54, 73]);
            }
          });

          mapMarker.events.add('balloonclose', (e) => {
            var target = e.get('target');
            if (target.geometry && typeof target.getGeoObjects) {
              target.options.set('iconImageSize', [36, 49]);
            }
          });

          restaurantsMap.geoObjects.add(mapMarker);
        }
      });
    };
    ymaps.ready(init);
  }
};

const mapHelper = (rests, defaultCoords) => {
  restaurants = rests;
  defaultCoordinates = defaultCoords;

  setTimeout(() => {
    const elem = document.createElement('script');
    elem.type = 'text/javascript';
    elem.src = `https://api-maps.yandex.ru/2.1/?apikey=${window.yandexMapsKey}&lang=ru_RU&onload=initYMap`;
    document.getElementsByTagName('body')[0].appendChild(elem);
  }, 500);
};

export default mapHelper;
